export default __webpack_public_path__ + "static/media/right-arrow-solid-white.8c1cf97d.svg";